import * as createHistory from "../../__snowpack__/pkg/history.js";
const history = createHistory.createBrowserHistory();
export default history;
